var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfind"},[_c('img',{attrs:{"src":require('@/assets/img/public/404-1.svg'),"alt":""}}),_c('router-link',{attrs:{"to":"/"}},[_c('el-button',[_vm._v("返回首页")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }